import axios from 'axios';

export const getRequest= async (endpoint) => {
  try {
    const response = await axios.get(endpoint);
    console.log('Get request successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Get request failed:', error.response ? error.response.data : error.message);
    throw error;
  }
};
